/**
 * Make sure you have the following import
 * <script data-app-key="j0ljsiidl5jokcn" id="dropboxjs" src="https://www.dropbox.com/static/api/1/dropbox.js" type="text/javascript"></script>
 */

app.registerConstructor("GoogleDriveStorage", function (opts) {
	const self = this;
	const apiKey = opts.apiKey;
	const clientId = opts.clientId;
	const scopes = opts.scopes;
	let oauthToken = null;

	const checkAuth = () => {
		let opts = {
			'client_id': clientId,
			'scope': scopes,
			'immediate': false
		};
		gapi.auth.authorize(opts, handleAuthResult);
	};

	const handleAuthClick = () => {
		checkAuth();
	};

	// Create and render a Picker object for searching docs.
	const createPicker = () => {
		const picker = new google.picker.PickerBuilder()
			.addView(google.picker.ViewId.DOCS)
			.setOAuthToken(oauthToken)
			.setCallback(pickerCallback)
			.build();
		picker.setVisible(true);
	};

	const withURL = (id, action) => {
		gapi.client.load('drive', 'v2', function() {
			const request = gapi.client.drive.files.get({
				'fileId': id
			});
			request.execute(function(resp) {
				let downloadurl;
				const accessToken = gapi.auth.getToken().access_token;
				if (typeof(resp.downloadUrl) !== "undefined") {
					downloadurl = resp.downloadUrl + "&access_token=" + accessToken;
				} else {
					downloadurl = resp['exportLinks']['application/pdf'] + "&access_token=" + accessToken;
				}
				action(downloadurl);
			});
		});
	};

	const pickerCallback = (data) => {
		if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
			const doc = data[google.picker.Response.DOCUMENTS][0];
			const id = doc[google.picker.Document.ID];
			const filename = doc[google.picker.Document.NAME];
			withURL(id, (url) => {
				const files = [{
					"name": filename,
					"source": "GOOGLE_DRIVE",
					"downloadLink": url
				}];
				app.vm.SocialStorageCommon.doRemoteRetrieveFile(files, remoteOnSocialStorageChosen)
			});
		}
	};

	const handleAuthResult = (authResult) => {
		if (authResult && !authResult.error) {
			oauthToken = authResult.access_token;
			google.load('picker', '1', {"callback": createPicker});
		} else {
			// handleAuthClick();
		}
	};

	self.newPicker = () => {
		gapi.client.setApiKey(apiKey);
		checkAuth();
	};
});
